module.exports = __webpack_public_path__ + "assets/img/2-1.766aaf44.svg";